export default __webpack_public_path__ + "static/Quick-Time-to-Market-8c2e8e065ebbf3e5789ac03fdc019484.webp";